export enum CardDispenserState {
  None = 'None',
  StartingTransaction = 'StartingTransaction',
  InTransaction = 'InTransaction',
  IssueCardTransaction = 'IssueCardTransaction',
  TakeCardTransaction = 'TakeCardTransaction',
  StoppingTransaction = 'StoppingTransaction',
}
